import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';

type PriceToFormat = Readonly<{
  price?: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  strikethrough?: true;
  dataE2e?: string | undefined;
}>;

export const useFormattedPrice = ({ price = 0, priceType, priceCurrency }: PriceToFormat) => {
  const { formatNumber } = useIntl();
  return {
    formattedNumber: formatNumber(price, { maximumFractionDigits: 4 }),
    formattedType: priceType === 'Percent' ? '%' : priceCurrency,
  };
};
export const Price: FC<PropsWithChildren<PriceToFormat>> = ({ children, ...props }) => {
  const { formattedNumber, formattedType } = useFormattedPrice(props);
  return (
    <div className="d-flex justify-content-between mt-3">
      <span
        className={classNames('display-3 tabular-figures', { 'text-strikethrough': props.strikethrough })}
        data-e2e={props.dataE2e}
      >
        {formattedNumber}
        {formattedType}
      </span>
      {children}
    </div>
  );
};
